import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, finalize, tap } from 'rxjs';
import { Router } from '@angular/router';
import { LoaderService } from '../services/loader.service';
import { environment } from 'src/environments/environment';
import { isBrowser } from '../isBrowser';

@Injectable()
export class AppInterceptor extends isBrowser implements HttpInterceptor {
	public baseUrl = environment.baseUrl;
	loading: boolean = false;
	router = inject(Router);
	loadingService = inject(LoaderService);

	constructor() {
		super(inject(PLATFORM_ID));
	}

	checkTokenType() {
		if (this.isBrowser) {
			if (localStorage?.getItem('customLogin_token')) {
				const parsed = JSON.parse(localStorage?.getItem('customLogin_token') as string);
				const accessToken: string = parsed.jwt;
				return accessToken;
			} else if (localStorage?.getItem('aiuser_data')) {
				const parsed = JSON.parse(localStorage?.getItem('aiuser_data') as string); // Msal token
				const accessToken: string = parsed.aiuser_token;
				return accessToken;
			}
		}
		return null;
	}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		//const salesAPI = `${this.baseUrl}/api/landing-catagories?populate[0]=landing_page_tiles&populate[1]=landing_page_tiles.Tile_img`;

		if (this.router.url.includes('login')) {
			return next.handle(request).pipe(finalize(() => this.loadingService.hide()));
		}
		if (this.checkTokenType()) {
			if (this.router.url.includes('sales')) {
				request = request.clone({
					setHeaders: {
						'X-access-token': this.checkTokenType() ?? '',
					},
				});
				this.loadingService.hide();
			}
		}

		return next.handle(request).pipe(
			tap(
				(evt: HttpEvent<unknown>) => {
					if (evt instanceof HttpResponse) {
						this.loadingService.hide();
					}
				},
				(err: HttpErrorResponse) => {
					if (err instanceof HttpErrorResponse) {
						this.loadingService.hide();
					}
				}
			)
		);
	}
}
